/**
 * @generated SignedSource<<2dd06959096e96384079d3683582585e>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type TOTPDeleteInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type TotpDeleteMutationMutation$variables = {|
  input: TOTPDeleteInput,
|};
export type TotpDeleteMutationMutation$data = {|
  +totpDelete: ?{|
    +clientMutationId: ?string,
  |},
|};
export type TotpDeleteMutationMutation = {|
  response: TotpDeleteMutationMutation$data,
  variables: TotpDeleteMutationMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TOTPDeletePayload",
    "kind": "LinkedField",
    "name": "totpDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TotpDeleteMutationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TotpDeleteMutationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dfe9582e27c25174b42baf5b2400ecbf",
    "id": null,
    "metadata": {},
    "name": "TotpDeleteMutationMutation",
    "operationKind": "mutation",
    "text": "mutation TotpDeleteMutationMutation(\n  $input: TOTPDeleteInput!\n) {\n  totpDelete(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "3a80bc758791f8afb9f428c62e1e2eff";

module.exports = ((node/*: any*/)/*: Mutation<
  TotpDeleteMutationMutation$variables,
  TotpDeleteMutationMutation$data,
>*/);
